<template>
  <div style="margin-top: 20px">
    <div class="container">
      <a-page-header
        style="background-color: #ffffff"
        title="确认订单"
        sub-title="请确认订单信息"
      />

      <!-- 收货地址 -->
      <div v-if="orderDetails.productType === '2'">
        <div class="order-address" style="padding: 10px 0px">
          <template v-if="this.addressList">
            <div
              class="addr-item-wrapper TwoRow"
              :class="{
                'addr-default': selectedIndex == index,
                'addr-selected': selectedIndex == index,
              }"
              v-for="(item, index) in addressList"
              :key="index"
              @click="selectAddr(item, index)"
            >
              <div class="inner-infos">
                <div class="addr-hd">
                  <span>{{ item.regionProvinceName }}</span>
                  <span>{{ item.regionCityName }}</span>
                  <span>{{ item.regionCountryName }}</span>
                  <span>{{ item.address }}</span>
                </div>
                <div class="addr-bd">
                  <div style="margin-top: 5px">
                    {{ item.name }} {{ item.tel }}
                  </div>
                </div>
              </div>
              <!-- <div class="curMarker"></div> -->
            </div>
          </template>

          <!-- ------------------------- -->
          <div class="addr-item-wrapper TwoRow">
            <div class="inner-infos">
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  height: 100%;
                "
              >
                <a-button type="primary" @click="insterAddress">
                  添加收货地址
                </a-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="outer-wrap">
        <div class="wrap">
          <div class="rent-box">
            <!-- <h2  class="rent-tit">核对订单信息</h2> -->
            <div class="rent-list">
              <div class="account">
                <div class="game-img">
                  <img :src="orderDetails.productImg" class="img" />
                </div>
                <div class="game-info">
                  <div class="tit">{{ orderDetails.productName }}</div>
                  <div class="des">
                    <span class="des-item"
                      >商品编号：{{ orderDetails.id }}</span
                    >
                    <span class="des-item">商品分类：</span>
                  </div>
                  <div class="tag">
                    <span class="tag-item blue tag-szq">{{
                      orderDetails.productTypeText
                    }}</span>
                    <span class="tag-item blue tag-bzmoney"
                      >库存:{{ orderDetails.inventoryQuantity }}</span
                    >
                  </div>
                </div>

                <div class="game-price">
                  <span class="price">{{ orderDetails.price }} 元</span>
                </div>
              </div>
              <div class="rent-sel-wrap">
                <div class="rent-item">
                  <div class="rent-tit">购买数量</div>

                  <div class="rent-mode">
                    <!-- 区间 -->
                    <template v-if="orderDetails.dealQuantityType === 1">
                      <el-input-number
                        v-model="orderForm.quantity"
                        :min="orderDetails.dealQuantityMin"
                        :max="orderDetails.dealQuantityMax"
                        placeholder="请选择下单数量"
                        size="small"
                      ></el-input-number>
                    </template>

                    <!-- 自定义 -->
                    <template v-if="orderDetails.dealQuantityType === 2">
                      <el-select
                        size="small"
                        v-model="orderForm.quantity"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="item in dealQuantityArray(
                            orderDetails.dealQuantityArray
                          )"
                          :key="item"
                          :label="item"
                          :value="item"
                        >
                        </el-option>
                      </el-select>
                    </template>
                  </div>
                </div>

                <!-- 下单参数 -->
                <div
                  class="rent-item"
                  v-if="this.orderDetails.orderParams.length > 0"
                >
                  <el-form label-position="left" label-width="88px">
                    <orderParam
                      :orderParams="orderDetails.orderParams"
                      v-model="orderDetails.orderParams"
                    ></orderParam>
                  </el-form>
                </div>

                <div class="rent-item">
                  <div class="rent-tit">订单备注</div>
                  <el-input
                    type="textarea"
                    placeholder="订单备注(非必填)"
                    v-model="orderForm.deliveryRemark"
                  >
                  </el-input>
                </div>
              </div>
            </div>

            <div class="hb-wrap">
              <div class="hb-box">
                <div class="rent-tit">支付方式</div>

                <div class="hb-wrap-hblist">
                  <div class="type pay-types">
                    <el-radio-group v-model="payConfigDetails">
                      <el-radio border label="balance">
                        余额支付（￥{{ balanceTotal }}）
                      </el-radio>
                      <el-radio
                        border
                        v-for="(value, key, index) in payList"
                        :key="index"
                        :label="value"
                        @change="toPopPayTis(value)"
                      >
                        {{ value.payName }}
                      </el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="hb-wrap">
              <div class="hb-box">
                <div class="hb-title">红包抵扣</div>
                <div class="hb-wrap-hblist">
                  <div class="hb-des">
                    <span class="high">暂无可用红包</span>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <!-- 支付 -->
      <div class="buy-wrap">
        <div class="buy-box">
          <div class="buy-btm">
            <div class="protocol active">
              <i class="icon-svg"></i>我已阅读并同意
              <span class="xieyi">《平台服务协议》</span>
            </div>
            <div class="pay-box">
              <div class="pay-price">
                实付总额：<span class="money">
                  ¥{{
                    $calculateProductPrice(
                      orderForm.quantity,
                      orderDetails.price,
                      orderDetails.orderParams
                    )
                  }}</span
                >
              </div>
            </div>

            <div style="margin-left: 20px">
              <a-button type="danger" @click="handleGoBuy()" v-preventClick>
                立即付款
              </a-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 支付弹框 -->
    <Payment
      ref="paymentComponent"
      :orderId="this.orderId"
      :payConfig="this.payConfigDetails"
      :orderParams="this.orderDetails.orderParams"
      :deliveryRemark="this.orderDetails.deliveryRemark"
    ></Payment>

    <!-- 添加收货地址 -->
    <a-modal
      title="添加收货地址"
      v-model:dialogVisible="dialogVisible"
      :modal-append-to-body="false"
      @cancel="dialogVisible = false"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-position="top"
      >
        <el-form-item label="姓名" prop="deliveryPerson">
          <el-input
            v-model="ruleForm.deliveryPerson"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>

        <el-form-item label="联系电话" prop="deliveryPhone">
          <el-input
            v-model="ruleForm.deliveryPhone"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>

        <el-form-item label="* 所在地区">
          <el-cascader
            v-model="fieldValue"
            :props="{
              value: 'id',
              label: 'regionName',
              children: 'children',
            }"
            :options="treeList"
            @change="handleChange"
          >
            <template slot-scope="{ node, data }">
              <span>{{ data.regionName }}</span>
              <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
            </template>
          </el-cascader>
        </el-form-item>

        <el-form-item label="详细地址" prop="deliveryAddress">
          <el-input
            v-model="ruleForm.deliveryAddress"
            placeholder="请输入详细地址"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <a-button type="primary" @click="submitForm('ruleForm')">
          确认
        </a-button>
        <a-button @click="dialogVisible = false">取消</a-button>
      </span>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Payment from "@/components/payment/Payment";
import orderParam from "@/components/orderParam.vue";
import { getAddressList } from "@/api/useraddress";
import { queryProductDetail } from "@/api/index";

import { Toast } from "vant";

import { regionTree, address } from "@/api/useraddress";
export default {
  data() {
    return {
      buttonLoading: false,

      dialogPayTisVisible: false,
      dialogPayTis: undefined,
      rules: {
        deliveryPerson: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        deliveryPhone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
        ],
        deliveryAddress: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
      },
      ruleForm: {
        deliveryPerson: undefined,
        deliveryPhone: undefined,
        deliveryAddress: undefined,

        //省
        regionProvince: undefined,
        regionProvinceName: undefined,

        regionCity: undefined,
        regionCityName: undefined,

        regionCountry: undefined,
        regionCountryName: undefined,
      },
      selectedIndex: undefined,
      addressList: [],
      payConfigDetails: "balance",
      dialogVisible: false,
      spaecsPirce: 0,
      payList: {},
      rechargeAccount: "",
      orderDetails: [],
      queryParam: {
        specsId: undefined,
        rechargeAccount: undefined,
      },
      orderForm: {
        addressId: undefined,
        //收件人姓名
        // deliveryPerson: null,
        //县编码
        // deliveryCountry: "",
        //省编码
        // deliveryProvince: null,
        //市编码
        // deliveryCity: null,
        //省名称
        // deliveryProvinceName: "",
        //城市名称
        // deliveryCityName: "",
        //地址
        // deliveryAddress: "",
        //手机号
        // deliveryPhone: "",
        //运费模版
        // deliveryConfigId: 1,
        // deliveryConfig: "",
        //成交平台 0:web 1:ios 2:android 3:wx
        // dealPlatform: 1,
        //备注
        deliveryRemark: "",
        //邮编
        // deliveryPostcode: "",
        //充值账号
        //充值数量
        quantity: undefined,
        //商品id
        productId: null,
        orderParams: [],
        stockId: undefined,
        treeList: [],
      },
    };
  },
  components: {
    Payment,
    orderParam,
  },
  computed: {
    ...mapGetters({}),
    ...mapState({
      orderDetail: (state) => state.order.orderDetail,
      payConfig: (state) => state.index.payConfig,
      orderState: (state) => state.order.orderState,
      balanceTotal: (state) => state.balance.balanceTotal,
      orderId: (state) => state.order.orderId,
    }),
  },
  created() {
    this.orderForm.quantity = this.$route.query.quantity;

    //查询我的余额
    this.$store.dispatch("balance/detail");

    //初始化支付通道
    this.initPayConfig();
    //获取获取商品详情
    this.getProductDetail();

    //查询收货地址
    this.queryAddressList();

    this.getRegionTree();
  },
  methods: {
    dealQuantityArray(value) {
      return value.split(",");
    },

    //初始化支付通道
    initPayConfig() {
      let data = {};
      this.$store.dispatch("index/queryPayConfig", data).then(() => {
        this.payList = this.payConfig.payList;
        // this.$forceUpdate();
      });
    },

    /**
     * 弹框支付提示
     */
    toPopPayTis(value) {
      let tip = value.payTip;
      if (tip) {
        this.dialogPayTisVisible = true;
        this.dialogPayTis = tip;
      }
    },

    //获取获取商品详情
    async getProductDetail() {
      let data = { product_id: this.$route.query.productId };
      const response = await queryProductDetail(data);

      this.orderDetails = response.result;
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          new Promise((resolve, rejust) => {
            address(this.ruleForm)
              .then((res) => {
                console.log(res);
                if (res.status == 0) {
                  Toast.success({
                    message: "添加成功",
                  });
                  this.dialogVisible = false;
                  this.queryAddressList();
                }
                resolve();
              })
              .catch((error) => {
                rejust(error);
              });
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //选择地区
    handleChange(selectedOptions) {
      //省
      this.ruleForm.regionProvince = selectedOptions[0];

      this.ruleForm.regionCity = selectedOptions[1];

      this.ruleForm.regionCountry = selectedOptions[2];
    },

    getRegionTree() {
      new Promise((resolve, rejust) => {
        regionTree({})
          .then((res) => {
            this.treeList = res.result;
            resolve();
          })
          .catch((error) => {
            rejust(error);
          });
      });
    },

    /**
     * 新增收货地址
     */
    insterAddress() {
      console.log("---------------------------------");
      this.dialogVisible = true;

      this.fieldValue = undefined;

      this.ruleForm.deliveryPerson = undefined;
      this.ruleForm.deliveryPhone = undefined;
      this.ruleForm.deliveryAddress = undefined;

      //省
      this.ruleForm.regionProvince = undefined;
      this.ruleForm.regionProvinceName = undefined;

      this.ruleForm.regionCity = undefined;
      this.ruleForm.regionCityName = undefined;

      this.ruleForm.regionCountry = undefined;
      this.ruleForm.regionCountryName = undefined;
    },

    //查询收货地址
    queryAddressList() {
      new Promise((resolve, rejust) => {
        getAddressList(this.queryParam)
          .then((res) => {
            this.addressList = res.result;
            resolve();
          })
          .catch((error) => {
            rejust(error);
          });
      });
    },

    /**
     * 选择收货地址
     */
    selectAddr(item, index) {
      this.selectedIndex = index;
      this.orderForm.addressId = item.id;
    },

    /**
     * 支付确认关闭事件
     */
    handleClose(done) {
      this.$confirm("确认取消支付？")
        .then(() => {
          done();
        })
        .catch(() => {});
    },

    //支付方法
    handleGoBuy() {
      //按钮状态
      this.buttonLoading = true;

      this.orderForm.productId = this.orderDetails.id;
      this.orderForm.orderParams = this.orderDetails.orderParams;
      this.orderForm.stockId = this.orderDetails.productStock.id;

      this.$store
        .dispatch("order/create", this.orderForm)
        .then(() => {
          this.$refs.paymentComponent.toPayment();

          // this.$router.push({
          //   path: "/confirmPayment",
          //   query: { orderId: this.orderId },
          // });
        })
        .catch((error) => {
          console.error(error);

          setTimeout(() => {
            this.buttonLoading = false;
          }, 3000);
        })
        .finally(() => {
          // 无论成功失败都会执行的逻辑
          setTimeout(() => {
            this.buttonLoading = false;
          }, 3000);
        });
    },

    //跳转到首页
    toIndex() {
      this.$router.push("/index");
    },
    /**
     * 返回上页
     */
    onClickLeft() {
      this.$router.back();
    },
  },
  // 离开页面销毁轮询器
  destroyed() {
    clearInterval(this.T);
  },
};
</script>

<style>
.account {
  background: #fafafa;
  border-radius: 10px 10px 0 0;
  padding: 16px 20px 16px 16px;
  display: flex;
}

.game-img {
  width: 96px;
  height: 96px;
  overflow: hidden;
  border-radius: 16px;
  flex: 0 0 96px;
}

.game-img .img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}

.game-info {
  flex: 1;
  margin: 0 20px 0 16px;
}

.game-info .tit {
  height: 22px;
  font-size: 16px;
  font-weight: 700;
  color: #262626;
  line-height: 22px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: justify;
  max-width: 820px;
}

.game-info .tit .icon {
  font-size: 12px;
  font-weight: 400;
  color: #fff;
  padding: 0 4px;
  margin-right: 4px;
  border-radius: 4px;
  background: #4bc234;
  display: inline-block;
  height: 16px;
  line-height: 15px;
  vertical-align: 2px;
}

.game-info .tit .icon.android {
  background: #4bc234;
}

.game-info .tit .icon.ios {
  background: #858cff;
}

.game-info .des {
  font-size: 13px;
  color: #4d4d4d;
  line-height: 18px;
  margin: 10px 0 22px;
}

.game-info .des .high {
  color: #3d8bff;
  font-style: normal;
}

.game-info .des .des-item:last-child:before {
  content: "";
  width: 1px;
  height: 13px;
  background: #cdcdcd;
  margin: 0 11px;
  display: inline-block;
  vertical-align: -2px;
}

.game-info .tag {
  margin: -6px 0 0 -6px;
}

.game-info .tag-item {
  display: inline-block;
  font-size: 12px;
  padding: 0 6px;
  border: 1px solid #eeeeee;
  margin: 6px 0 0 6px;
  border-radius: 4px;
  height: 24px;
  line-height: 22px;
  box-sizing: border-box;
}

.game-info .tag-item.blue {
  color: #262626;
  background-color: #f3f6fc;
  border-color: #ccd2de;
}

.game-info .tag-item.yellow {
  color: #ff5a2e;
  background-color: #ffdbce33;
  border-color: #ffc3ad;
  position: relative;
}

.game-info .tag-item.yellow:hover .goods-flag-tip {
  display: block;
}

.game-info .tag-item.red {
  color: #f6194f;
  background-color: #ff4c791a;
  border-color: #ff4c79;
}

.game-info .tag-item.tag-szq {
  padding: 0 6px 0 4px;
}

.game-info .tag-item.tag-szq .icon-svg {
  display: inline-block;
  width: 16px;
  height: 16px;
  overflow: hidden;
  vertical-align: -4px;
  background: none;
  margin-right: 2px;
}

.game-info .tag-item.tag-szq .icon-svg:before {
  content: "";
  background: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/szq.1abbabc8.svg)
    no-repeat;
  display: inline-block;
  width: 16px;
  height: 16px;
  background-size: 100% 100%;
  transform: translate(80px);
  filter: drop-shadow(#657088 -80px 0);
}

.game-info .tag-item.tag-bzmoney {
  padding: 0 6px 0 4px;
}

.game-info .tag-item.tag-bzmoney .icon-svg {
  display: inline-block;
  width: 16px;
  height: 16px;
  overflow: hidden;
  vertical-align: -4px;
  background: none;
  margin-right: 2px;
}

.game-info .tag-item.tag-bzmoney .icon-svg:before {
  content: "";
  background: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/bzmoney.bae04e69.svg)
    no-repeat;
  display: inline-block;
  width: 16px;
  height: 16px;
  background-size: 100% 100%;
  transform: translate(80px);
  filter: drop-shadow(#657088 -80px 0);
}

.game-info .tag-item.tag-time {
  padding: 0 6px 0 4px;
}

.game-info .tag-item.tag-time .icon-svg {
  display: inline-block;
  width: 16px;
  height: 16px;
  overflow: hidden;
  vertical-align: -4px;
  background: none;
  margin-right: 2px;
}

.game-info .tag-item.tag-time .icon-svg:before {
  content: "";
  background: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/time.39c932cb.svg)
    no-repeat;
  display: inline-block;
  width: 16px;
  height: 16px;
  background-size: 100% 100%;
  transform: translate(80px);
  filter: drop-shadow(#657088 -80px 0);
}

.game-info .tag-item .goods-flag-tip {
  display: none;
  color: #000000a6;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
  position: absolute;
  z-index: 99;
  visibility: visible;
  line-height: 1.5;
  font-size: 12px;
  transform-origin: 0px -4px 0px;
  white-space: nowrap;
  top: 30px;
  left: -12px;
}

.game-info .tag-item .goods-flag-tip:before {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
  top: -5px;
  border-width: 0 5px 5px;
  border-bottom-color: #fff;
  left: 16px;
}

.game-info .tag-item .goods-flag-tip .tips {
  display: block;
  padding: 6px 12px 6px 8px;
  color: #666;
  text-align: left;
  text-decoration: none;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px #00000026;
  min-height: 20px;
  word-break: break-all;
}

.game-price {
  text-align: right;
  display: inline-block;
  align-self: center;
}

.game-price .price {
  height: 22px;
  font-size: 18px;
  font-weight: 500;
  color: #262626;
  line-height: 22px;
}

.game-price .vip-price {
  height: 16px;
  border-radius: 4px;
  border: 1px solid #ffe1d3;
  padding-right: 5px;
  position: relative;
  color: #8e301d;
  line-height: 16px;
  display: flex;
  align-items: center;
  overflow: hidden;
  box-sizing: border-box;
  font-size: 12px;
  margin-top: 4px;
}

.game-price .vip-price .tag {
  display: inline-block;
  background: linear-gradient(139deg, #ffeae0 0%, #ffe1d3 100%);
  border-radius: 4px 0 0 4px;
  padding: 0 4px;
  margin-right: 5px;
}

.rent-sel-wrap {
  padding: 24px 16px 18px;
}

.rent-item {
  display: flex;
  margin-top: 24px;
}

.rent-item:first-child {
  margin-top: 0;
}

.rent-mode .mode-item {
  display: inline-block;
  width: 500px;
  /* height: 32px;
  line-height: 32px; */
  text-align: center;
  border-radius: 6px;
  /* border: 1px solid #C3C7CF; */
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 700;
  color: #262626;
  cursor: pointer;
  margin-right: 10px;
}

.rent-mode .mode-item:hover,
.rent-mode .mode-item.active {
  color: #ff3d3d;
  background: #fffafa;
  /* border: 1px solid #FF3D3D */
}

.rent-mode .mode-item.disabled {
  background: #ccc;
  color: #6e6d6d;
  border: 1px solid #c3c7cf;
  cursor: not-allowed;
}

.rent-mode .mode-tips {
  color: #666;
  font-size: 12px;
  color: #737373;
  line-height: 17px;
}

.rent-mode .mode-tips .icon-svg {
  display: inline-block;
  width: 13px;
  height: 21px;
  overflow: hidden;
  vertical-align: -3px;
  background: none;
  margin-right: 2px;
  display: none;
}

.rent-mode .mode-tips .icon-svg:before {
  content: "";
  background: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/vip-tips.c09c5ae3.svg)
    no-repeat;
  display: inline-block;
  width: 15px;
  height: 15px;
  background-size: 100% 100%;
  transform: translate(80px);
  filter: drop-shadow(#666666 -80px 0);
}

.yuyue-tips {
  font-size: 14px;
  font-weight: 700;
  color: #262626;
  line-height: 32px;
}

.window-box {
  z-index: 1001;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
}

.pop-upBox {
  width: 760px;
  height: 440px;
  z-index: 100;
  position: absolute;
  top: 50%;
  left: 50%;
  padding: 0 28px;
  transform: translate(-50%, -50%);
  background: white;
}

.pop-upBox .important-title {
  text-align: center;
  color: #383838;
  font-size: 38px;
  line-height: 38px;
  padding: 32px 0 12px;
  font-weight: 700;
}

.pop-upBox .tips-sam {
  font-size: 14px;
  text-align: center;
  color: #828282;
  margin-bottom: 40px;
}

.tip-contend {
  width: 700px;
  height: 110px;
  padding: 20px 30px;
  background: #fafafa;
  margin: 0 auto;
}

.lol_sure {
  color: #fff;
  background: #e4272a;
  margin-right: 24px;
}

.lol_exit {
  color: #fc3737;
  background: #ffeaea;
}

.lol_sure:hover {
  box-shadow: 0 5px 18px #fc373780;
}

.clearfixd:after {
  content: "";
  display: block;
  height: 0;
  visibility: hidden;
  clear: both;
}

.clearfixd {
  zoom: 1;
}

.vip-hb-btn {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.vip-hb-btn .tit {
  font-size: 14px;
  font-weight: 700;
  color: #4d4d4d;
}

.vip-hb-btn .tit:before {
  display: inline-block;
  content: "";
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAABZJJREFUSEt9V31olVUY/511FbOFYFosLCJJ/zAz+lJMc607nc6v5aZzXiudTjddKpZJw5SwDxNlEjo/GmGujJRABcmaQ4lKQ0PzK1EDtamZIropzuv7PHE+3/O+u3hhu7vvzjnPeX7P7/n9nitgXswsJk6YOw2EcgL3AXE2g8EkfwNMpFYys/uJfiawWmjWyw96bSszHwNQ/8Pur74QQshVEPJXKjU3J2hDAzHn6YPlIXIjQOaAMIgOYC+gn5ug8qLyf6T3+xdW64iasjplpXbtargoZKZl4+c1EpEJqi5kNprsyHum0tLBSD73MoxfRkaOI0TMTbv3fpMUpePnTOeA12uUYtkYWGUgMlnYS4UBPYi9MijE5L4Qco2iflWICcVz9hFRf3eQraWtry5cBF6XmQenOtIGVqlm4oMtCfaLknHVLWDO1iSydSW3MZpteAFXDnNRl5lHRIlSJkKCuVWUFM1mnwg2eLQ2XkDmKHx+pn5pOLy8hViRzvBHjBtbpWN5m/yg7Tc5uDQnTLtJmP0O8LOV8CkiGjTkX2LcmCqVsd8uclFp6QiUFOcjC8DVK9fw0af1OHX6bFhHZiQ6JLDw7TI898xTEDJwEMiekUzEtestWF63FYePn9H97QWVD0TR6EqFYzzjDeuWoPtDXTQTidDc/C9mz/sM6XTaZZbMfQHV5UUgCsCBhJbUuxIbJpy/cBmVNWvUZeNoiKJRM9V9Qmg0lKlJhSguSoKDQAsCEbZ834hNm3c6cRjcvy/mV5a4gCowkc6cCOeb/0PVB3WRpOQFZDJi7MgZDmo/eCKRwOcrFyDnka4ui7vpO5izsBZnz13Sm7MEVi6pxBM9usuGBZMOqNALAnyyZgt+/eOvjL0sxhRWaFbH+lWm/XSfnli6aKbJWB968vQ5vLNotUOod88eWPb+VBdYXZ4IB4+cwuJV3xrp1fKpIDctJkaPmKafeWbg2osZ1TNKkBzyvDpY1lIeumHjdmz/8TenZtVTRyN/YD9DLkb6ThpVS9bhwqWrmlSWWFbNiCBGDdeB1U3izgLGA507YfXy+ejyYGcNIwW4fasNVQtrcfnqdYVGdnZnrF1ahez7O6gENm/fi693/BzpgLjDiZEF5WE7ORWK6u+gAX3x7qxSDblpmQOHTmLxik2uDQc82wvVkwtx+MTfWFG/DW3pu6rPtRhae9Xv8iVGFkxl+UHR3ahKqLmhD9fMnYQX+/XSDDYXWL5uK/buOxqy1mm1p9uZ/FtCXTh0Csc911Le7+9uXbtg9cez0KlDQvOBAty43oIZNXW4cfNW1B49J4ucLVvNJCiG57+lwZCHxWTTImCZWJj3EirKCsK2IULjL4dQ++WOe0wmpmNi/BHDk2+GJhET9nbGDmDZe1PQ+8lHNdGkuDBjwbKNOH7mn3B4MEn4pXMoWpMoeO2NCNQ2u6gdhibyeE43rFpUrjTcSuP6737Ctt0HHInaWWGGKUUMy5uspSODd0acyWyWdZ84ajBKRwxUWd+8eRuVH27AlWvS1s3UYc/yvFrPcHYQJIihr6YySGaoZM7OPHVLZGWhZubr6PnYw6jduBO/Hzl9zxrHpxsJu8jPneQkM2qPbjyNTIsRl5GXiSEVn8Xa+bkZBkQyt6yFibOjdbGNb10rOupaQfD32M7wSeTboZ08jCe0iuQrE/cRc3+fwZENXl10naLTSnyu8mcxGyyD3+8XySGl04mw3p+HHBFibIwf0C5oTLkyjbY6Y1GhBvq8QRMaGcjLdFB0SAhFJhMfnOx6Q11kv1a0pqOn9iTVV5hhg1M5t4O2BmbO82fjTGpmfTvO9mi7eMT01BBAU8f7OqYOnth1UQU2dRG5LxdPI2JpV30k4bQvtx/O4/3t6ur5rqsvuFUwjjGo/s+Te9yXtv8BVcczb9kzj9kAAAAASUVORK5CYII=)
    no-repeat;
  width: 15px;
  height: 15px;
  background-size: 100% 100%;
  margin-right: 6px;
  vertical-align: -2px;
}

.vip-hb-btn .no-vip-txt {
  font-size: 14px;
  color: #999;
  margin-left: 17px;
}

.vip-hb-btn .btn-wrap {
  margin-left: 17px;
}

.vip-hb-btn .btn {
  display: inline-block;
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
  border: 1px solid #c3c7cf;
  padding: 0 12px;
  font-size: 14px;
  color: #262626;
  text-align: center;
  margin-right: 10px;
  cursor: pointer;
  position: relative;
  box-sizing: border-box;
}

.vip-hb-btn .btn .icon-svg {
  display: inline-block;
  width: 16px;
  height: 21px;
  overflow: hidden;
  vertical-align: -2px;
  background: none;
  margin-right: 6px;
}

.vip-hb-btn .btn .icon-svg:before {
  content: "";
  background: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/sel_no.d2b368ec.svg)
    no-repeat;
  display: inline-block;
  width: 16px;
  height: 16px;
  background-size: 100% 100%;
  transform: translate(40px);
  filter: drop-shadow(#c3c7cf -40px 0);
}

.vip-hb-btn .btn.active {
  border-color: #ff3d3d;
}

.vip-hb-btn .btn.active .icon-svg:before {
  background: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/sel_act.48319abd.svg)
    no-repeat;
  background-size: 100% 100%;
  filter: drop-shadow(#ff3d3d -40px 0);
}

.vip-hb-btn .vip-tips {
  margin-left: 0;
}

.vip-tips {
  height: 32px;
  font-size: 12px;
  color: #ff724d;
  line-height: 32px;
  font-style: normal;
  background: rgba(255, 114, 77, 0.08);
  border-radius: 4px;
  padding: 0 16px 0 8px;
  display: inline-block;
}

.vip-tips .icon-svg {
  display: inline-block;
  width: 13px;
  height: 20px;
  overflow: hidden;
  vertical-align: -2px;
  background: none;
  margin-right: 4px;
}

.vip-tips .icon-svg:before {
  content: "";
  background: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/vip-tips.c09c5ae3.svg)
    no-repeat;
  display: inline-block;
  width: 15px;
  height: 15px;
  background-size: 100% 100%;
  transform: translate(40px);
  filter: drop-shadow(#ff724d -40px 0);
}

.hb-lf {
  height: 100%;
  display: flex;
  align-items: center;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAAA9CAMAAAA9KQ86AAAApVBMVEUAAAD/9fX/7e3/7u7/7Oz/7Oz/7e3/6+v/7e3/7Oz/7e3/6+v/7Oz/7e3/7e3/7e3/7e3/6en/7Oz/7Oz/7e3/7e3/7e3/7e3/7e3/7e3/7e3/7+//8PD/7u7/7e3/7e3/7e3/7e3/7e3/7e3/7u7/7e3/7u7/7Oz/7e3/7Oz/7e3/7e3/7e3/7e3/7u7/7u7/7e3/7e3/7Oz/7Oz/7e3/7+//7OzaU0WBAAAANnRSTlMAA/sq+OznB9nCOhb0ua9qRBHx3NPLqpuKYVUjHA6khX5ZUDULkkz24dCzdXJtXS/HkHlAnyEZWuUBAAACJklEQVRYw9WX23aiQBBFhSCKFyCgeEMRxJh4i2OS+v9Pm8lynI5woLr0afYzawvdXee0jf8XI93avTDyHze9tOlCv/uY6KlP/2g/4nr+ZdIPtvcvktekW6Z3mvwBFQlb94hmLgHOctE8sQjRi6WmiU0VfMpEnSFVsxKI4gXVcdIWtZY9queoaZq+Eoed64jeHdIg4UXdkUk6bL64RdoHpMmCjRJtzJiJEgHHmiixSMSEiRIBT9j08UZSHGyK+CPZLp7/DlaxG//+Zwmym+2NGveohp2/8TUEKyVR2WqnZmZhpUQqazyHa3oWq9zZzXM71TpC1aBY63t11EWqpmcUn/ukK2uBylw/lwMoUL+Ta6v6YLONLSmWmqowQ/Xq3GztSkcV7FqgXsdWYSk/WJU56mrWa5TFRp3KWYnqtbdpOoccqV5Tpl4hg25JtVnmuF45nKIqimG9ysJZRQmsVx57rlT2xJDWKy5rFSW4Xnms2fU79OvVdL30DErF5esVz6ZX/nK/+qaOCF+uTxzKh8tg6xXPplH+fI+vVzyb43JUFgPuyyUFmE3whThZ82QDNGg2E/DeP+PyaOPxB7OJsmL7vWOXKDkhD57NadXl5pT4qxQvEp5NH6fFvtFYEKZyNgkzUq9bBM/mLqBqVStkap6dTdVoGax58dW3Aw9v82CA2VzXBtjbZabGoOaFV1/rutdZiGoe/4vGplTtzHTRDqpr3uUa7HtIfwPL2dA3n73zwAAAAABJRU5ErkJggg==);
  background-repeat: no-repeat;
  background-size: 73px 60px;
  background-position: 0 bottom;
}

.hb-price {
  font-weight: 700;
  width: 100px;
  display: flex;
  align-items: baseline;
  justify-content: center;
  margin-right: 4px;
  color: #ff3d3d;
}

.hb-price span,
.hb-price i {
  font-size: 16px;
  font-weight: 700;
}

.hb-price b {
  font-size: 32px;
  font-weight: 700;
}

.hb-btn {
  width: 72px;
  height: 28px;
  border-radius: 15px;
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  margin-right: 15px;
  flex: 0 0 72px;
}

.hb-rt {
  flex: 1;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.hb-rt.exclusive-rt {
  text-align: right;
}

.hb-box {
  display: flex;
  font-family: PingFangSC-Medium, PingFang SC;
}

.hb-title {
  font-size: 14px;
  font-weight: 500;
  color: #4d4d4d;
  margin-right: 11px;
  height: 32px;
  line-height: 32px;
}

.hb-title:before {
  width: 14px;
  height: 16px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAgCAYAAAABtRhCAAAAAXNSR0IArs4c6QAABIxJREFUSEuVl21oVmUYx3/3o6uoNR2Gsqx0pizyU0QM15e1BEHSyFn4staL20pDIltpS7CIEmQQGCotJYgh2Ieo2BdjrJkIG9SnWizW5hBLqB4b7Yl065wrzjn3fZ/73M/ZpMGz5+Xc53r5X9f1v/5Hof9ERHG8q41QdiGyljCsRIBQQMyL5HP0W3QxftPX4nPOdyghjACnePvYSaVUdBUV/ZMPu2qYCXsJpSkxGGpDxoBnOLopE4hxZs6FOih7boCCalHv9VxRcWYfvNFPECTOopc16DiKr2kDcZQmMO9MnL1/Lr53gCMfrVdydH87QdhjoXJhsfA5GcXGIgQSVBHz2YHdXvdKIXQoeb9ziEDqk+zcaHPqZWpn4XTOZJBxUXKdMqyke980QmVaE52BC0tZ4zhZuRBap/q6uZbCX1LS1yv88K2XnelEtzny6hkm9bL1zYPX6egHG1By7R/h4264+nvaWaZ2/jjY32MvTqfOUwqT5ZKlcOAdoi4Vir/B6eMwVcwamc9o1BiZ8cgZHRNg9RLYux+W1aDkl0nhzhVQ+gtOn4BfL6XD/X+7NFMz3Sx3r4Q9nbBoMVwcR8m7rwjbOmDVfUm7D30N/V/C9esOw2j4FlXDxq1wb12S3c+j8MUZmPrTYxyBm2+Bx5rhkQ1QKMCP38OxbpQc2iOoAjRtgoZHYcECKE3Ddxdg+BsoRrUNoaoaXn0Lbq00bJi8/12Cw2/C1NWkHHcshYcboaERbq+CIICzffD5GZj9FyUHXxTLMMuWw+YdsHJ12n2XJ+HiGNxVC6vWZJ2Zb+M/weQErK6De2pBxYwJY6PwyUm4fMnaU9LVIenA6xlcvgLWNcID9VBxU76TuX6dmYHhCzD4FUyMp4HrWVZyoD1xaOgo7kzd9gsXJpnVroENj0NFRb6b2Vno+yzJaGIMIqdzbBIlr7dpSD2G8WewdTc8tC7fYZRRz1F/Q5SvNRGUdO5KHGYI111Lmj2qFsPBw3Cb1zSlEhx6DYp/ZLdEhndTkley7zmxPOoOsuVI7TC6FnVq83aouz8xPjoCn/ZCsZhdyC65G4LQm0XJy88k1G4OucPrc6Rlnnm2RN7WsU4jSPe2pjXMyAWzYnII2a2vKzfyVIBHgUpeakkgjRvT2RIZAs8j5zkC8RHybCvZvTMdC9+p20gmegP/jc7G53yCjyB9YUfKNP4mz1Vrcyg5FxEblFlhKUJK2ralDm3Bfa3iRut0bRSgraFj3GTn6yMBJc8/lRQwjlA7srj7DJSne7xaZlByAtVoKXn2yfwMXfxtxK5DT2S5jtwMPeGlpHXrNCKVqbp2jPoCyUDkqzd3jnPn0OrdkpKnm4cIw3pL4JmbNXUGjliyznSGLhnkyY4sWQwr2dncThj0lNGbdezW6EYS0q+x16WFQkci9bc/0U8QNpUpsQwPaoK3geQQRZna0wFE9yg1wLlz65OHmZYtNVyb7SUMm+ZV32U1deW9/1yi2cs4E2lR589f0VogmgpRbNmkH9eCtRk1XjZXZnzicLN70IyYUiVERigUTjE4aB/X/gMsQwAzZgHFmgAAAABJRU5ErkJggg==)
    no-repeat;
  background-size: 100% 100%;
  margin-right: 6px;
  vertical-align: -3px;
  content: "";
  display: inline-block;
}

.vip-tips {
  height: 32px;
  font-size: 12px;
  color: #ff724d;
  line-height: 32px;
  font-style: normal;
  background: rgba(255, 114, 77, 0.08);
  border-radius: 4px;
  padding: 0 16px 0 8px;
  display: inline-block;
  margin-left: 10px;
}

.vip-tips .icon-svg {
  display: inline-block;
  width: 13px;
  height: 20px;
  overflow: hidden;
  vertical-align: -2px;
  background: none;
  margin-right: 4px;
}

.vip-tips .icon-svg:before {
  content: "";
  background: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/vip-tips.c09c5ae3.svg)
    no-repeat;
  display: inline-block;
  width: 15px;
  height: 15px;
  background-size: 100% 100%;
  transform: translate(40px);
  filter: drop-shadow(#ff724d -40px 0);
}

.hb-des {
  display: inline-block;
  height: 32px;
  line-height: 32px;
  background: #fffafa;
  border-radius: 4px;
  padding: 0 12px 0 16px;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: #262626;
  cursor: pointer;
}

.hb-des.tips {
  background: transparent;
}

.hb-des .high {
  color: #ff3d3d;
}

.hb-des .icon-svg {
  display: inline-block;
  width: 16px;
  height: 18px;
  overflow: hidden;
  vertical-align: -2px;
  background: none;
  margin-left: 5px;
  position: relative;
}

.hb-des .icon-svg:before {
  content: "";
  background: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/arrow_up.440e416d.svg)
    no-repeat;
  display: inline-block;
  width: 16px;
  height: 16px;
  background-size: 100% 100%;
  transform: rotate(-180deg) translate(80px);
  filter: drop-shadow(#ff3d3d -80px 0);
}

.hb-des .pop-arrow {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
  top: -8px;
  left: 100px;
  border-top-color: #fff;
  z-index: 10;
  border-width: 8px;
}

.tcpay_con p.tcpay_ye {
  font-size: 13px;
  font-weight: 700;
  height: 35px;
  line-height: 35px;
  text-align: left;
  padding-left: 15px;
  background: #f6f6f6;
  margin-bottom: 15px;
}

.line_through {
  text-decoration: line-through;
}

.buy-wrap {
  /* position: fixed;
  left: 0;
  right: 0;
  bottom: 0; */
  min-height: 78px;
  background: #ffffff;
  overflow: hidden;
  border-top: 1px solid #ebebeb;
  z-index: 10;
  margin-bottom: 100px;
}

.buy-wrap.active {
  box-shadow: 0 -4px 8px #0000001a;
}

.buy-box {
  width: 1300px;
  margin: 0 auto;
}

.buy-top {
  text-align: right;
  margin-bottom: 22px;
  padding-top: 32px;
}

.buy-top .buy-item {
  display: flex;
  align-items: center;
  margin-top: 12px;
  line-height: 20px;
}

.buy-top .buy-item:first-child {
  margin-top: 0;
}

.buy-top .buy-item .name {
  font-size: 14px;
  font-weight: 400;
  color: #4d4d4d;
  margin-right: 85px;
  flex: 1;
}

.buy-top .buy-item .val {
  font-size: 14px;
  font-weight: 500;
  color: #262626;
  width: 194px;
  flex: 0 0 194px;
  text-align: left;
}

.buy-top .bzmoney .icon-svg {
  display: inline-block;
  width: 13px;
  height: 14px;
  overflow: hidden;
  vertical-align: -2px;
  background: none;
  margin-right: 4px;
}

.buy-top .bzmoney .icon-svg:before {
  content: "";
  background: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/vip-tips.c09c5ae3.svg)
    no-repeat;
  display: inline-block;
  width: 15px;
  height: 15px;
  background-size: 100% 100%;
  transform: translate(40px);
  filter: drop-shadow(#3d8bff -40px 0);
}

.buy-top .bzmoney .name {
  position: relative;
}

.buy-top .bzmoney .name:hover .tips {
  display: block;
}

.buy-top .bzmoney .name .tips {
  width: 340px;
  position: absolute;
  top: -5px;
  right: 56px;
  height: 30px;
  line-height: 30px;
  background: #fff;
  z-index: 1;
  text-align: left;
  color: #666;
  padding: 0 5px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px #00000026;
  display: none;
  cursor: pointer;
  font-size: 12px;
}

.buy-top .bzmoney .name .tips:after {
  right: -7px;
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
  top: 11px;
  border-width: 0px 5px 5px;
  border-bottom-color: #fff;
  transform: rotate(85deg);
}

.buy-top .hb .icon {
  width: 14px;
  height: 16px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAgCAYAAAABtRhCAAAAAXNSR0IArs4c6QAABIxJREFUSEuVl21oVmUYx3/3o6uoNR2Gsqx0pizyU0QM15e1BEHSyFn4staL20pDIltpS7CIEmQQGCotJYgh2Ieo2BdjrJkIG9SnWizW5hBLqB4b7Yl065wrzjn3fZ/73M/ZpMGz5+Xc53r5X9f1v/5Hof9ERHG8q41QdiGyljCsRIBQQMyL5HP0W3QxftPX4nPOdyghjACnePvYSaVUdBUV/ZMPu2qYCXsJpSkxGGpDxoBnOLopE4hxZs6FOih7boCCalHv9VxRcWYfvNFPECTOopc16DiKr2kDcZQmMO9MnL1/Lr53gCMfrVdydH87QdhjoXJhsfA5GcXGIgQSVBHz2YHdXvdKIXQoeb9ziEDqk+zcaHPqZWpn4XTOZJBxUXKdMqyke980QmVaE52BC0tZ4zhZuRBap/q6uZbCX1LS1yv88K2XnelEtzny6hkm9bL1zYPX6egHG1By7R/h4264+nvaWaZ2/jjY32MvTqfOUwqT5ZKlcOAdoi4Vir/B6eMwVcwamc9o1BiZ8cgZHRNg9RLYux+W1aDkl0nhzhVQ+gtOn4BfL6XD/X+7NFMz3Sx3r4Q9nbBoMVwcR8m7rwjbOmDVfUm7D30N/V/C9esOw2j4FlXDxq1wb12S3c+j8MUZmPrTYxyBm2+Bx5rhkQ1QKMCP38OxbpQc2iOoAjRtgoZHYcECKE3Ddxdg+BsoRrUNoaoaXn0Lbq00bJi8/12Cw2/C1NWkHHcshYcboaERbq+CIICzffD5GZj9FyUHXxTLMMuWw+YdsHJ12n2XJ+HiGNxVC6vWZJ2Zb+M/weQErK6De2pBxYwJY6PwyUm4fMnaU9LVIenA6xlcvgLWNcID9VBxU76TuX6dmYHhCzD4FUyMp4HrWVZyoD1xaOgo7kzd9gsXJpnVroENj0NFRb6b2Vno+yzJaGIMIqdzbBIlr7dpSD2G8WewdTc8tC7fYZRRz1F/Q5SvNRGUdO5KHGYI111Lmj2qFsPBw3Cb1zSlEhx6DYp/ZLdEhndTkley7zmxPOoOsuVI7TC6FnVq83aouz8xPjoCn/ZCsZhdyC65G4LQm0XJy88k1G4OucPrc6Rlnnm2RN7WsU4jSPe2pjXMyAWzYnII2a2vKzfyVIBHgUpeakkgjRvT2RIZAs8j5zkC8RHybCvZvTMdC9+p20gmegP/jc7G53yCjyB9YUfKNP4mz1Vrcyg5FxEblFlhKUJK2ralDm3Bfa3iRut0bRSgraFj3GTn6yMBJc8/lRQwjlA7srj7DJSne7xaZlByAtVoKXn2yfwMXfxtxK5DT2S5jtwMPeGlpHXrNCKVqbp2jPoCyUDkqzd3jnPn0OrdkpKnm4cIw3pL4JmbNXUGjliyznSGLhnkyY4sWQwr2dncThj0lNGbdezW6EYS0q+x16WFQkci9bc/0U8QNpUpsQwPaoK3geQQRZna0wFE9yg1wLlz65OHmZYtNVyb7SUMm+ZV32U1deW9/1yi2cs4E2lR589f0VogmgpRbNmkH9eCtRk1XjZXZnzicLN70IyYUiVERigUTjE4aB/X/gMsQwAzZgHFmgAAAABJRU5ErkJggg==)
    no-repeat;
  background-size: 100% 100%;
  margin-right: 6px;
  vertical-align: -3px;
}

.buy-top .hb .val {
  color: #ff3d3d;
}

.buy-top .short .hui {
  display: inline-block;
  width: 18px;
  height: 18px;
  background: #ff3d3d;
  border-radius: 2px;
  color: #fff;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  font-style: normal;
  margin-right: 6px;
}

.buy-top .short .name,
.buy-top .short .val {
  color: #ff3d3d;
}

.buy-top .vip .icon {
  width: 15px;
  height: 15px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAABZJJREFUSEt9V31olVUY/511FbOFYFosLCJJ/zAz+lJMc607nc6v5aZzXiudTjddKpZJw5SwDxNlEjo/GmGujJRABcmaQ4lKQ0PzK1EDtamZIropzuv7PHE+3/O+u3hhu7vvzjnPeX7P7/n9nitgXswsJk6YOw2EcgL3AXE2g8EkfwNMpFYys/uJfiawWmjWyw96bSszHwNQ/8Pur74QQshVEPJXKjU3J2hDAzHn6YPlIXIjQOaAMIgOYC+gn5ug8qLyf6T3+xdW64iasjplpXbtargoZKZl4+c1EpEJqi5kNprsyHum0tLBSD73MoxfRkaOI0TMTbv3fpMUpePnTOeA12uUYtkYWGUgMlnYS4UBPYi9MijE5L4Qco2iflWICcVz9hFRf3eQraWtry5cBF6XmQenOtIGVqlm4oMtCfaLknHVLWDO1iSydSW3MZpteAFXDnNRl5lHRIlSJkKCuVWUFM1mnwg2eLQ2XkDmKHx+pn5pOLy8hViRzvBHjBtbpWN5m/yg7Tc5uDQnTLtJmP0O8LOV8CkiGjTkX2LcmCqVsd8uclFp6QiUFOcjC8DVK9fw0af1OHX6bFhHZiQ6JLDw7TI898xTEDJwEMiekUzEtestWF63FYePn9H97QWVD0TR6EqFYzzjDeuWoPtDXTQTidDc/C9mz/sM6XTaZZbMfQHV5UUgCsCBhJbUuxIbJpy/cBmVNWvUZeNoiKJRM9V9Qmg0lKlJhSguSoKDQAsCEbZ834hNm3c6cRjcvy/mV5a4gCowkc6cCOeb/0PVB3WRpOQFZDJi7MgZDmo/eCKRwOcrFyDnka4ui7vpO5izsBZnz13Sm7MEVi6pxBM9usuGBZMOqNALAnyyZgt+/eOvjL0sxhRWaFbH+lWm/XSfnli6aKbJWB968vQ5vLNotUOod88eWPb+VBdYXZ4IB4+cwuJV3xrp1fKpIDctJkaPmKafeWbg2osZ1TNKkBzyvDpY1lIeumHjdmz/8TenZtVTRyN/YD9DLkb6ThpVS9bhwqWrmlSWWFbNiCBGDdeB1U3izgLGA507YfXy+ejyYGcNIwW4fasNVQtrcfnqdYVGdnZnrF1ahez7O6gENm/fi693/BzpgLjDiZEF5WE7ORWK6u+gAX3x7qxSDblpmQOHTmLxik2uDQc82wvVkwtx+MTfWFG/DW3pu6rPtRhae9Xv8iVGFkxl+UHR3ahKqLmhD9fMnYQX+/XSDDYXWL5uK/buOxqy1mm1p9uZ/FtCXTh0Csc911Le7+9uXbtg9cez0KlDQvOBAty43oIZNXW4cfNW1B49J4ucLVvNJCiG57+lwZCHxWTTImCZWJj3EirKCsK2IULjL4dQ++WOe0wmpmNi/BHDk2+GJhET9nbGDmDZe1PQ+8lHNdGkuDBjwbKNOH7mn3B4MEn4pXMoWpMoeO2NCNQ2u6gdhibyeE43rFpUrjTcSuP6737Ctt0HHInaWWGGKUUMy5uspSODd0acyWyWdZ84ajBKRwxUWd+8eRuVH27AlWvS1s3UYc/yvFrPcHYQJIihr6YySGaoZM7OPHVLZGWhZubr6PnYw6jduBO/Hzl9zxrHpxsJu8jPneQkM2qPbjyNTIsRl5GXiSEVn8Xa+bkZBkQyt6yFibOjdbGNb10rOupaQfD32M7wSeTboZ08jCe0iuQrE/cRc3+fwZENXl10naLTSnyu8mcxGyyD3+8XySGl04mw3p+HHBFibIwf0C5oTLkyjbY6Y1GhBvq8QRMaGcjLdFB0SAhFJhMfnOx6Q11kv1a0pqOn9iTVV5hhg1M5t4O2BmbO82fjTGpmfTvO9mi7eMT01BBAU8f7OqYOnth1UQU2dRG5LxdPI2JpV30k4bQvtx/O4/3t6ur5rqsvuFUwjjGo/s+Te9yXtv8BVcczb9kzj9kAAAAASUVORK5CYII=)
    no-repeat;
  background-size: 100% 100%;
  margin-right: 6px;
  vertical-align: -2px;
}

.buy-top .vip .val {
  color: #ff3d3d;
}

.buy-top .bean .icon {
  width: 18px;
  height: 18px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAuxJREFUOE+tk21olWUYx3/X/TzPOds5yl507MW3TWQYQ9o0kPYhqHSCKApRkLExRfwwg4yICCL2ZRR9ESGwWFG01YexzA++o2jEtiBhYhQKKo7NNffqOp7tnOftjvs8bs7h9Es3PNwf7vv53f/r/78u4X9aspCjp3uL8Wb3QfgySBKRW/gcl9LXbz/vvXmQHj67A+V3IF4JSoM2Rwq0k0I5r0lJw9VnwXIgPXTiRfD6UNl8LAtsG7AgDCHQuKmZG7GhgU3yaqu/FCwCDXRcgPR2nBCcJNgJ0BYELvhZ8EP6u7taNr9/9viSIH2nvZQwM4ykFY6CvGKwl4M44M+ClwZ3hivtP44lyle/sPXdXyaeBhN986udhBOnUSlwLIgXPQnyU+CmOfflCTL/zl7Y+0HTbqlpdRfDRP99tBF/9AfUNDgCsWVgLQNsCDPgP4wUdfYy8NcgiLpUXbvlrfrW85MLYaKvf74Hb+QkagIsDywH7HjkkTYeZSDIMnhjijPf/oHvBSQLCwebj37RJFWNV+ZgovvbavFG+tEjYKVBNLnkzAp9CL1ox+Z6z33+7BuhYOUKdh1pCXCKD0tV49fmquiuNy3WlY/jDxWiHgDZXPJoDQQQGFgY9ZTEorLtleBUQHyti120RjY0jUbx9x3pxBt6BxkHUoAPEkYwPbebmwpUHqgCcMogVgmx1QekpuW7CNT7UT3uvR7CYZBpIAMSgDnNgeY+ibxTJpBSiFcaVZ9I3cdtj0fk10PduPfeQI8BaVBeVJrxbE5ZYIAGlARVAvH1kKzcL1s+/f4x6PKHZQTDv+P+sw5tkp0FMSUao3Xkk7HKtAXGpzJIrJ8iWVEtL7WOPzn9lw9tJPvgDO5oFfpRidooyxEgNNdjoAohb5VHYtXb8sqxn3OpLe5QfWpfEVbwGd50M8HDODoLOsiJyqmxzCwW9ZNf/J5s++a3+T5aagj1xYOlZCcbCLw6grAAxQw4d8lPXJKGn64t/u8/QVAxIopE5eAAAAAASUVORK5CYII=)
    no-repeat;
  background-size: 100% 100%;
  margin-right: 6px;
  vertical-align: -1px;
}

.buy-top .bean .val {
  color: #ff3d3d;
}

.buy-top .te-vip,
.buy-top .gift {
  justify-content: end;
}

.buy-top .gift .moneyTxt {
  display: inline-block;
}

.buy-top .gift .icon-svg {
  display: inline-block;
  width: 16px;
  height: 16px;
  overflow: hidden;
  vertical-align: -3px;
  background: none;
  margin-right: 8px;
}

.buy-top .gift .icon-svg:before {
  content: "";
  background: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/xieyi_no.6a83da5f.svg)
    no-repeat;
  display: inline-block;
  width: 16px;
  height: 16px;
  background-size: 100% 100%;
  transform: translate(80px);
  filter: drop-shadow(#c3c7cf -80px 0);
}

.buy-top .gift.active .icon-svg:before {
  background: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/xieyi_act.63fd20cf.svg)
    no-repeat;
  background-size: 100% 100%;
  filter: drop-shadow(#ff3d3d -80px 0);
}

.buy-top .complaints {
  justify-content: end;
}

.buy-top .complaints_warp {
  position: relative;
  top: -6px;
}

.buy-top .complaints_warp:before {
  content: "";
  width: 12px;
  height: 12px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAABC0lEQVQoU2NkgIL/oVpsvyU40v7+Z4hm/M+gDRL+z8hwlZmRYSnrix+zGFdf+wUSYwQR3zL0pZmYWbYwMPx//P8/Yz8Hw/fTIPEfDJymjIz/CxkYGGX//f3jwzXj4lNGkMk/xThPMjIwrGKferYdpPB7ttFhEM059ZwtiP6ZbVz5n4EhjP3Vd3PGX7lGOf/+MbhxTD3nB3MeugawbdlGm5iYGHYxfs8xOs7wj7GKc9rZ/TAN2OjvWcaODEz/2xh/ZBt9Yv//Q4px2rUvMIU/s43mgtjsU88lwwMlS4vnJyPHM6wavmcbg23jnHrWEUMDNidh0wB3EnZPY9oA9zS2YEX3A0qwkhxxpCYNAF9XquVKiED3AAAAAElFTkSuQmCC)
    no-repeat;
  background-size: 100%;
  margin-top: 2px;
  margin-right: 2px;
}

.buy-btm {
  display: flex;
  align-items: center;
  padding: 20px;
}

.buy-btm .protocol {
  font-size: 13px;
  font-weight: 400;
  color: #262626;
  cursor: pointer;
}

.buy-btm .protocol .xieyi {
  color: #3d8bff;
}

.buy-btm .protocol .icon-svg {
  display: inline-block;
  width: 16px;
  height: 16px;
  overflow: hidden;
  vertical-align: -3px;
  background: none;
  margin-right: 8px;
}

.buy-btm .protocol .icon-svg:before {
  content: "";
  background: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/xieyi_no.6a83da5f.svg)
    no-repeat;
  display: inline-block;
  width: 16px;
  height: 16px;
  background-size: 100% 100%;
  transform: translate(80px);
  filter: drop-shadow(#c3c7cf -80px 0);
}

.buy-btm .protocol.active .icon-svg:before {
  background: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/xieyi_act.63fd20cf.svg)
    no-repeat;
  background-size: 100% 100%;
  filter: drop-shadow(#ff3d3d -80px 0);
}

.buy-btm .pay-box {
  flex: 1;
  text-align: right;
}

.buy-btm .pay-box .pay-price {
  font-size: 14px;
  font-weight: 500;
  color: #262626;
  height: 33px;
  line-height: 33px;
}

.buy-btm .pay-box .money {
  font-size: 24px;
  font-weight: 500;
  color: #ff3d3d;
  vertical-align: -4px;
}

.buy-btm .pay-box .yh-des {
  line-height: 18px;
  font-weight: 400;
}

.buy-btm .pay-box .yh {
  font-size: 12px;
  color: #737373;
  margin-right: 12px;
}

.buy-btm .pay-box .des {
  font-size: 13px;
  color: #3d8bff;
  cursor: pointer;
}

.buy-btm .pay-box .des .icon-svg {
  display: inline-block;
  width: 16px;
  height: 16px;
  overflow: hidden;
  vertical-align: -2px;
  background: none;
  margin-left: 5px;
}

.buy-btm .pay-box .des .icon-svg:before {
  content: "";
  background: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/arrow_up.440e416d.svg)
    no-repeat;
  display: inline-block;
  width: 16px;
  height: 16px;
  background-size: 100% 100%;
  transform: translate(80px);
  filter: drop-shadow(#3d8bff -80px 0);
}

.buy-btm .pay-box .des .icon-svg.active {
  vertical-align: -4px;
}

.buy-btm .pay-box .des .icon-svg.active:before {
  transform: rotate(-180deg) translate(80px);
}

.protocol {
  font-size: 13px;
  font-weight: 400;
  color: #262626;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.protocol span {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999;
  line-height: 17px;
  margin-left: 8px;
}

.protocol .icon-svg {
  display: inline-block;
  width: 16px;
  height: 16px;
  overflow: hidden;
  vertical-align: -3px;
  background: none;
}

.protocol .icon-svg:before {
  content: "";
  background: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/xieyi_no.6a83da5f.svg)
    no-repeat;
  display: inline-block;
  width: 16px;
  height: 16px;
  background-size: 100% 100%;
  transform: translate(80px);
  filter: drop-shadow(#c3c7cf -80px 0);
}

.protocol.active .icon-svg:before {
  background: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/xieyi_act.63fd20cf.svg)
    no-repeat;
  background-size: 100% 100%;
  filter: drop-shadow(#ff3d3d -80px 0);
}

.rent-item {
  display: flex;
  margin-top: 24px;
}

.rent-tit {
  height: 20px;
  font-size: 14px;
  font-weight: 700;
  color: #4d4d4d;
  line-height: 20px;
  width: 88px;
  flex: 0 0 88px;
  line-height: 32px;
}

.jsq-item {
  min-width: 880px;
  /* height: 66px; */
  /* padding: 12px 16px; */
  border-radius: 8px;
  box-sizing: border-box;
  background: linear-gradient(122deg, #fffafd 0%, rgba(255, 244, 252, 0) 100%);
}

.jsq-item .jsq-select-checked {
  width: 14px;
  height: 14px;
  border-radius: 2px;
  border: 1px solid #cdcdcd;
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
  top: 3px;
  cursor: pointer;
}

.jsq-item .jsq-select-checked.active {
  background: #ff3636
    url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAQAAABUDBdwAAAASUlEQVQI12NgQAL/w/5fQua6/f/5v5rh/+X/YWCuxf8v/yeAGNVAcbf/2v/f/l/0nxGidML/z/+f/d/8nwWml/H/nP97/nNCeAAd7CelovhmPQAAAABJRU5ErkJggg==)
    no-repeat center center;
  border-color: #ff3636;
}

.jsq-item .jsq-opt {
  display: inline-flex;
  align-items: center;
  font-size: 12px;
}

.jsq-item .jsq-name {
  font-weight: 700;
  font-size: 14px;
  color: #262626;
  line-height: 19px;
  margin-left: 10px;
  margin-right: 8px;
  cursor: pointer;
}

.jsq-item .jsq-money {
  font-weight: 700;
  font-size: 14px;
  color: #ff3d3d;
  line-height: 19px;
  cursor: pointer;
}

.jsq-item .jsq-card {
  width: 44px;
  height: 16px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #fff;
  line-height: 1;
  background: linear-gradient(150deg, #ff997c 0%, #ff3d3d 100%);
  border-radius: 4px;
  margin: 0 6px 0 10px;
}

.jsq-item .jsq-card.disabled {
  margin-left: 16px;
  background: linear-gradient(150deg, #d6d6d6 0%, #c1c1c1 100%);
}

.jsq-item .jsq-daoqi {
  margin-left: 16px;
}

.jsq-item .jsq-daoqi:before {
  content: "";
  width: 1px;
  height: 14px;
  background: #ebebeb;
  display: inline-block;
  position: relative;
  top: 3px;
}

.jsq-item .jsq-tips {
  color: #ff893d;
  margin-left: 4px;
}

.jsq-item .jsq-endtime {
  color: #737373;
}

.jsq-item .jsq-endtime span {
  color: #262626;
}

.jsq-hint {
  border-radius: 2px;
  color: #a06767;
  font-size: 12px;
  line-height: 12px;
  padding: 8px 3px 3px 18px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAIKADAAQAAAABAAAAIAAAAACshmLzAAAEF0lEQVRYCe1VW4hVVRj+1lahFBkvxVgQU0njvReTetLG42g1OFnQTM1LOur4kLdO4qEH6UT5UBKaTTfBQYmMGCgp6aGMAsOXIKJ6SaRAsDCMyubMOWfvvdbf/6999j7HPS49+9ijCxbrsv/1f99/3cCN8T95gPbtuov27hjIqk5lfZCWp735LlCYB9EjPD0obFJ7hg+n5VznlgnQK7unw6/shzEbAQIMTzvIh1I5VXzrGxdo431LBOilbXOhzZdscQfPOnidxAW0zbhHFV79txHsSnvvSpdXu6Pis7MQ6M8Q6g6EBkwkmvE+1ODv7bj45+6r6Ym/ZSaAYPwIgrDTAkdgYDJMgqdda4QCk6edQ7fFQK41EwF6fstCBlmbgMfWy9rogYjQVOjqEy7g+D4TAQbfaoEEQACNPsOWn0RIFWt97AH5ZmWC5TGQa81GINAr6zFnEuQ9ow4c7cYszGSAbq6Ewxz/hryg+1zA8X3TBKgw1MYWd0aWsYXafK72j5wURap4pAIdXkQY5pLwRN64ZhVMjpm4Vtr29Fw29WGMlR/jmo/K1nDtTUIhfkObBh6Frz+AppvtnWGC0hYULsQyrtVJgLZuWAnjv8lWzU+ajCi2g46pdz/8PlG6OjiBE3gQHg0yiS22NwgBMqcTGcfGHYKg+jYn2nzr8sZsl31g5tD6vs20caBD9Kq+UQn8NPjm8UReQkCTjjlwk2s3Aa1vSRLOgoZRZkuShTrHnjkEvzoomuipdc8x+Bd8d6t9Y2XM75i35GyC5Ng4WzFt6DvHrr+D4x49lZZrpyDaAP8C3HQ/zPgwy/TbmE+QwXFMmdavRkd9Bz7cHgh16TJ3iheS+rZeOIhw7Cvuiv3JfVom0OtQvvQJDQ1NaYGA+e2y9hqVVa3G8TeX3Ytc84stuADbMEkqyKydZfXDNTj3a7+LgLMKWNHL7Na72b132sfyp6u7eAZnOJ9rapNvfK7LNOzNpZrkhMWZA7EkDfZOxz9mDjeh26HVUibWzf/75UxsalSeQoyl41+xEIj7gCgx9C26uh5QxSIznjiuSSD9hIYLizDme/j6x9lc891sMU8sZY94kfX8QghFnhDQZerUqe/SeuJz0wTotTy3YXOcQRdYa4l+ALw+tef1n6mnZyZKpV72Tp4V3xsr5/UNBt/ecJ6wdedAWnTMH2GACFySixjI0KdENE8p9ReLH5VJK1aIV57k/R9ob38hrSZ9bt4Dhc2as9uz8ZV4S5xl9bBEHXzvp7TiZs/Ne6BUOcugnZCoxuC8w2Qt1rc83I0orbIcfIxSFRjnWebGJut49YB6Z/R8WjTLOQuBQyhzkxfgUoVJBPvw/ke7soBdtyytXTNCPavPU89DvdetrBUFlMu106pVba28vfHG5YH/AAikeBmWBvHJAAAAAElFTkSuQmCC)
    no-repeat;
  background-size: 16px;
  background-position-y: 7px;
  margin-left: 22px;
}

.rent-list {
  border-radius: 10px;
  border: 1px solid #eeeeee;
  box-sizing: border-box;
  background-color: #ffffff;
}

.rm-item {
  background-color: #fff;
  border-radius: 8px;
  padding: 32px 106px 0 0;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
}

.rm-item .rm-title {
  font-size: 20px;
  font-weight: 700;
  color: #262626;
  line-height: 1;
  padding-bottom: 24px;
  padding-left: 32px;
}

.hb-wrap {
  background: #ffffff;
  padding: 20px 0 20px 16px;
  border-radius: 10px;
  border: 1px solid #eeeeee;
  margin-top: 20px;
}

.hb-box {
  display: flex;
  font-family: PingFangSC-Medium, PingFang SC;
}

.hb-title {
  font-size: 14px;
  font-weight: 500;
  color: #4d4d4d;
  margin-right: 11px;
  height: 32px;
  line-height: 32px;
}

.hb-list-box {
  display: none;
  position: absolute;
  right: 0;
  left: 0;
  bottom: 32px;
  bottom: 40px;
  max-height: 348px;
  max-height: 388px;
  background: #ffffff;
  box-shadow: 0 4px 12px #0000001a;
  border-radius: 6px;
  box-sizing: border-box;
  padding: 0 20px 30px 26px;
  overflow: auto;
  width: 1096px;
}

.el-form-item__label {
  font-weight: 700;
}

/* 收件地址css */

.order-address .content-container .mobile {
  color: grey;
  font-weight: 700;
}

.order-address .content-container .selected-description {
  display: inline;
  color: #f40;
  line-height: 26px;
  margin-left: -80px;
  margin-right: 18px;
}

.order-address .content-container .selected-description .marker {
  font-family: tp-buy-font;
  font-size: 22px;
  font-style: normal;
  color: #f40;
  line-height: 26px;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}

.order-address .content-container .selected-description .marker-tip {
  font-weight: 700;
}

.order-address .content-container .need-update {
  display: inline;
  color: #f40;
  font-weight: 700;
  position: relative;
}

.order-address .content-container .need-update .a4-tip-span {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  top: -12px;
  left: 15px;
  border: 7px solid transparent;
  border-top-color: #fdb08e;
  z-index: 102;
}

.order-address .content-container .need-update .a4-tip-span .a4-tip-icon {
  position: absolute;
  width: 0;
  height: 0;
  top: -8px;
  left: -6px;
  border: 6px solid transparent;
  border-top-color: #fff0e8;
}

.order-address .content-container.selected {
  margin-right: 66px;
}

.order-address .address-contents.checked .next-radio-label {
  font-size: 14px;
  font-weight: 700;
}

.order-address .failure-icon {
  color: #f40;
}

.order-address .failure-icon,
.order-address .success-icon {
  font-family: tp-buy-font;
  font-style: normal;
  font-size: 18px;
  height: 18px;
  line-height: 18px;
  background-image: none;
  padding-left: 6px;
}

.order-address .success-icon {
  color: #4dbf00;
}

.order-address .addr-item-wrapper.OneRow {
  position: relative;
  padding-left: 92px;
  border: 1px solid #fff;
  line-height: 30px;
  margin: 5px 0;
}

.order-address .addr-item-wrapper.OneRow .modify-operation {
  position: absolute;
  right: 10px;
  bottom: 0;
  margin-left: 10px;
}

.order-address .addr-item-wrapper.OneRow .default-tip,
.order-address .addr-item-wrapper.OneRow .set-default {
  display: none;
}

.order-address .addr-active.addr-item-wrapper.OneRow {
  background-color: #fff0e8;
}

.order-address .addr-selected.addr-item-wrapper.OneRow {
  border-color: #f40;
  background-color: #fff0e8;
  box-shadow: 5px 5px 0 #f3f3f3;
}

.order-address .addr-selected.addr-item-wrapper.OneRow .mask {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.2;
  filter: progid:DXImageTransform.Microsoft.Alpha(opacity=20);
  background-color: #000;
  z-index: 100;
  width: 100%;
  height: 100%;
}

.order-address .addr-default.addr-item-wrapper.OneRow .default-tip {
  display: inline;
}

.order-address
  .addr-not-default.addr-active.addr-item-wrapper.OneRow
  .set-default {
  display: inline;
  margin-left: 4px;
  vertical-align: middle;
}

.order-address .addr-item-wrapper.TwoRow {
  display: inline-block;
  vertical-align: top;
  position: relative;
  width: 237px;
  margin-right: 15px;
  color: #666;
  cursor: pointer;
}

.order-address .addr-item-wrapper.TwoRow .inner-infos {
  height: 110px;
  z-index: 2;
  position: relative;
  padding: 11px 15px;
  background: url(//img.alicdn.com/tps/i2/T1VPiBXvpeXXbjLKQ7-237-106.png)
    no-repeat;
  overflow: hidden;
}

.order-address .addr-item-wrapper.TwoRow .default-tip,
.order-address .addr-item-wrapper.TwoRow .set-default {
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 2px;
  text-decoration: none;
  filter: alpha(opacity=70);
  opacity: 0.7;
  z-index: 3;
}

.order-address .addr-item-wrapper.TwoRow .default-tip {
  background: #ccc;
  color: #fff;
}

.order-address .addr-item-wrapper.TwoRow .set-default {
  color: #666;
  background: #fff;
}

.order-address .addr-item-wrapper.TwoRow .set-default:hover {
  color: #c97;
}

.order-address .addr-item-wrapper.TwoRow .failure,
.order-address .addr-item-wrapper.TwoRow .success {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 2px;
  opacity: 0.7;
  z-index: 4;
  background-color: #fff5cc;
}

.order-address .addr-active.addr-item-wrapper.TwoRow .inner-infos,
.order-address .addr-selected.addr-item-wrapper.TwoRow .inner-infos {
  background-image: url(//img.alicdn.com/tfs/TB1OVRCRpXXXXaMXFXXXXXXXXXX-237-106.png);
}

.order-address .addr-selected.addr-item-wrapper.TwoRow .inner-infos .addr-bd {
  height: 36px;
}

.order-address .addr-default.addr-item-wrapper.TwoRow .default-tip,
.order-address
  .addr-selected.addr-not-default.addr-active.addr-item-wrapper.TwoRow
  .set-default {
  display: block;
}

.order-address .operations {
  display: block;
  position: relative;
}

.order-address .operations .manage-link {
  position: absolute;
  right: 0;
  cursor: pointer;
}

.order-address .operations .operation.OneRow {
  margin-left: 118px;
}
</style>
